var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClarityArrowLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_277_4064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.195 13.83L15 8.99998L10.195 4.16998C10.1516 4.11299 10.0965 4.066 10.0333 4.03217C9.9702 3.99834 9.90053 3.97848 9.82904 3.97392C9.75756 3.96935 9.68593 3.98021 9.61901 4.00573C9.55208 4.03126 9.49142 4.07087 9.44114 4.12188C9.39085 4.17289 9.35211 4.23411 9.32754 4.30139C9.30297 4.36867 9.29315 4.44045 9.29873 4.51186C9.30431 4.58327 9.32517 4.65265 9.35989 4.7153C9.39462 4.77795 9.4424 4.8324 9.5 4.87498L13.095 8.49998L3.53 8.49998C3.39739 8.49998 3.27022 8.55266 3.17645 8.64643C3.08268 8.74019 3.03 8.86737 3.03 8.99998C3.03 9.13259 3.08268 9.25977 3.17645 9.35353C3.27022 9.4473 3.39739 9.49998 3.53 9.49998L13.095 9.49998L9.5 13.125C9.40651 13.2191 9.35425 13.3466 9.35472 13.4792C9.35519 13.6119 9.40835 13.739 9.5025 13.8325C9.59665 13.926 9.72409 13.9782 9.85677 13.9778C9.98945 13.9773 10.1165 13.9241 10.21 13.83H10.195Z",
    fill: "#1E1E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_277_4064"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "matrix(0 1 -1 0 18 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClarityArrowLine);
export default __webpack_public_path__ + "static/media/clarity_arrow-line.59211269d699af93a3cbbb6a41445f39.svg";
export { ForwardRef as ReactComponent };